import * as React from "react";
import styled from "@emotion/styled";
import breakpoint from "@/utils/breakpoint";
import { useTheme } from "@/hooks/useTheme";
import Footer from "@/components/organisms/Footer";
import Header from "@/components/organisms/NewHeader";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f7f7f7;
  padding-top: 30px;
  padding-bottom: 339px;
`;

const Title = styled.h1<{ color?: string }>`
  font-size: 24px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 2.4px;
  font-weiht: 700;
  color: ${({ color = "#002b69" }) => color};
  opacity: 1;
  ${breakpoint.lessThan("sm")`
  padding: 0 10px;
 `}
`;

const Message = styled.p`
  font-size: 14px;
  letter-spacing: 0px;
  color: #333333;
  font-weight: 400;
  opacity: 1;
  text-align: left;
`;

const SubDescription = styled.div`
  width: 80%;
  margin-top: 30px;
  background-color: #ffffff;
  border-radius: 5px;
  opacity: 1;
  padding: 30px 48px 30px 48px;
  ${breakpoint.lessThan("sm")`
  width: 95%;
  padding: 28px 15px;
`}
`;

const ErrorPageWrapper = styled.div`
  font-family: Noto Sans JP;
  overflow-x: hidden;
`;

const ErrorPage = () => {
  const { COLOR_THEME } = useTheme();
  return (
    <ErrorPageWrapper>
      <Header isDescriptionEnabled={false} />
      <Wrapper role="main">
        <Title color={COLOR_THEME.extras?.primary}>システムエラーが発生しました</Title>
        <SubDescription>
          <Message>システムエラーが発生しました。</Message>
          <Message>少しお時間をおいてから、再度アクセスをお試しください。</Message>
        </SubDescription>
      </Wrapper>
      <Footer />
    </ErrorPageWrapper>
  );
};

export default ErrorPage;
